import { useQuery } from '@tanstack/react-query';

import { fetchPatientReferrals } from '../api/fetchPatientReferrals';

export function usePatientReferralsQuery(userId: string | undefined) {
  return useQuery({
    queryKey: ['patient-referrals', userId ?? ''],
    queryFn: ({ signal }) => fetchPatientReferrals(userId ?? '', signal),
    enabled: Boolean(userId),
    meta: {
      toast: {
        title: 'Could not load referrals',
        description: 'Patient referrals could not be fetched.',
      },
    },
  });
}
